import { useCallback, useEffect, useState } from "react";
import { fetchAgents, fetchSrmUsers } from "../../models/shared/agentsUsersModel";

export function useAgentsUsers() {
  const [agents, setAgents] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async ({ force = false } = {}) => {
    setLoading(true);
    const [a, u] = await Promise.all([fetchAgents({ force }), fetchSrmUsers({ force })]);
    setAgents(a);
    setUsers(u);
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const refresh = useCallback(() => load({ force: true }), [load]);

  return { agents, users, loading, refresh };
}
